import { useIsMounted } from '@ui/hooks/useIsMounted';
import { useMemo } from 'react';
import { useAccount } from 'wagmi';

/**
 * wagmi connection store is hydrated after initial mount to prevent hydration error
 * the server status of the hook is always 'disconnected' making it hard to check whether user is connected
 * on page refresh
 *  if user was disconnected, status: 'disconnected' -> 'connecting' -> 'disconnected'
 *  if user was connected,    status: 'disconnected' -> 'connecting' -> 'connected'
 * added mount check to skip the initial 'disconnected' status
 * so we can decide user's actual connection status
 */
export const useIsConnectedOnload = () => {
  const isMounted = useIsMounted();
  const { status } = useAccount();

  return useMemo(() => {
    if (!isMounted) return null;
    if (status === 'connecting') return null;

    return status === 'connected';
  }, [isMounted, status]);
};
